import { defineAction } from '~/prix'
import { z } from 'zod'
import systemCheckAction from './systemCheck.action.json' with { type: 'json' }

const systemCheckDefinition = defineAction({
  ...systemCheckAction,

  input: z.any(),
  output: z.object({
    database: z.boolean(),
    cache: z.boolean(),
    internet: z.boolean(),
  }),
})

export default systemCheckDefinition
